$('#SubmitForm #submit_button').on('click', function (e) {
    e.preventDefault();

    const form = $("#SubmitForm");
    const isRecaptcha = $(this).hasClass("recaptchaButton");

    if (!form.valid()) {
        setTimeout(() => {
            if (!document.title.includes("Error")) {
                document.title = "Error - " + document.title;
            }
            $(window).scrollTop($('.validation-summary-errors').first().offset().top);
        }, 200);
        return;
    }

    const submitForm = () => form.submit();

    const recaptchaFail = () => {
        $('[data-valmsg-for=FormSubmissionError]')
            .append(
                'Sorry, there is a problem with this form. Try again later. <a href="/contact-us">Contact us</a> if you need to speak to someone.'
            )
            .addClass('field-validation-error')
            .wrap("<div class='m-form-error'></div>");
    };
 // If button has class 'recaptchaButton' (added if Recaptcha turned on in Sitecore), use Recaptcha, otherwise submit directly.
    if (isRecaptcha) {
        validateRecaptcha(submitForm, recaptchaFail);
    } else {
        submitForm();
    }
});


// Amend page title for all forms with validation on page load
	let prefabTitle = function () {
	let errorDiv = $(".validation-summary-errors span");
	if (errorDiv.length) {

		titleText = document.title;

		if (titleText.includes("Error") == false) {
			titleText = 'Error - ' + titleText;
			document.title = titleText;
		}
        }

};

// add aria-hidden="true" to hidden recaptcha field to hide from screen readers

window.addEventListener("load", function () {
    var el = document.querySelector("textarea.g-recaptcha-response");
    if (el) {
        el.setAttribute("aria-hidden", "true");
        el.removeAttribute("aria-label");
        el.setAttribute("tabindex", "-1");
    }
});
``
